module.exports = __webpack_public_path__ + "static/media/bf.048afb99.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/bf.svg
// module id = 2045
// module chunks = 0